module.exports = __webpack_public_path__ + "static/media/utkarsh.ee9aca17.jpg";